module.exports = __webpack_public_path__ + "img/logo-nirvana-memorial-garden.86fe2ff5.67167452.svg";